"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = NumberFormatter;

var _propTypes = require("../propTypes");

NumberFormatter.propTypes = _propTypes.EditorProps;

function NumberFormatter(_ref) {
  var _column$options, _column$options2;

  var row = _ref.row,
      column = _ref.column;
  var value = row[column.key];
  var format = ((_column$options = column.options) === null || _column$options === void 0 ? void 0 : _column$options.format) || "decimal";
  var precision = format === "integer" ? 0 : ((_column$options2 = column.options) === null || _column$options2 === void 0 ? void 0 : _column$options2.precision) || 0;
  return typeof value === "number" ? "".concat(Number(value).toFixed(precision)) : null;
}